import { createApi } from '@reduxjs/toolkit/query/react';

import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const logsApi = createApi({
  reducerPath: 'logsApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getLogs: builder.query({
      /**
       * params = {
       *   page: 1,
       *   per_page: 20,
       *   event: 'deleted',
       *   subject_type: 'User',
       *   causer_name: 'Peter',
       *   date_from: '2024-01-01',
       *   date_to: '2024-12-31',
       *   ...
       * }
       */
      query: (params = {}) => {
        const search = new URLSearchParams(params).toString();
        return {
          url: `${urls.logs}?${search}`,
        };
      },
    }),
    getLog: builder.query({
      query: (id) => ({
        url: urls.logsDetail(id),
      }),
    }),
  }),
});

export const { useGetLogsQuery, useGetLogQuery } = logsApi;
